import React, { createContext, useContext } from "react";

import type { GlobalSettings } from "@fl-purchase/core";
import type { ReactNode } from "react";

const GlobalSettingsContext = createContext<GlobalSettings | undefined>(undefined);

export const GlobalSettingsProvider: React.FC<{ settings: GlobalSettings; children: ReactNode }> = ({ settings, children }) => (
  <GlobalSettingsContext.Provider value={settings}>{children}</GlobalSettingsContext.Provider>
);

export const useGlobalSettings = (): GlobalSettings => {
  const context = useContext(GlobalSettingsContext);
  if (!context) {
    throw new Error("useGlobalSettings must be used within a GlobalSettingsProvider");
  }

  return context;
};
